export default "__VITE_ASSET__oFbvaKMc__"